import type { ReactNode } from "react";

export interface FloatingInputProps {
  id: string;
  label: string;
  icon: ReactNode;
  type?: string;
  required?: boolean;
  value: string;
  onChange: (e: { target: { value: string } }) => void;
  error?: string;
  phoneOnly?: boolean;
}

export function FloatingInput({
  id,
  label,
  icon,
  type = "text",
  required,
  value,
  onChange,
  error,
  phoneOnly,
}: FloatingInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (phoneOnly) {
      const allowed = /^[+\d\s\-()]*$/;
      if (!allowed.test(val)) {
        e.target.value = val.replace(/[^+\d\s\-()]/g, "");
      }
    }
    onChange(e);
  };
  const hasError = !!error && !!value;
  return (
    <div className="space-y-1.5">
      <div className="floating-field relative">
        <input
          id={id}
          name={id}
          type={type}
          required={required}
          value={value}
          onChange={handleChange}
          placeholder=" "
          className={`block w-full rounded-xl border bg-transparent px-4 pb-3 pt-5 text-sm text-slate-900 transition-colors duration-200 focus:ring-0 focus:shadow-[0_0_0_3px_rgba(44,120,185,0.08)] ${
            hasError
              ? "border-red-400 focus:border-red-500"
              : "border-slate-200 focus:border-[#2C78B9]"
          }`}
        />
        <label
          htmlFor={id}
          className="inline-flex items-center gap-1.5"
        >
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            {icon}
          </span>
          {label}
        </label>
      </div>
      {hasError && (
        <p className="text-xs text-red-600 font-medium">{error}</p>
      )}
    </div>
  );
}
